<form class="uk-container" #orderForm="ngForm" (ngSubmit)="send(orderForm)">
	<h2 class="Heading Heading--marginLeft uk-margin-xlarge-top">Контактная информация</h2>
	<div class="OrderUserInfo ContainerSmall">
		<div *ngIf="!userService.user" class="uk-child-width-1-2 uk-child-width-1-3@m uk-child-width-1-4@l uk-grid" uk-grid>
			<div>
				<input class="uk-input"
					type="text"
					[(ngModel)]="name"
					name="name"
					placeholder="Имя *"
					required
				>
			</div>

			<div>
				<input class="uk-input"
					type="text"
					[(ngModel)]="lastName"
					name="lastName"
					placeholder="Фамилия"
				>
			</div>

			<div>
				<input class="uk-input"
					type="text"
					[(ngModel)]="phone"
					name="phone"
					placeholder="Телефон *"
					required
					[textMask]="{mask: phoneMask}"
					pattern="^\+[1-9]\s\(\d{3}\)\s\d{3}-\d{2}-\d{2}$"
				>
			</div>

			<div>
				<input class="uk-input"
					type="email"
					[(ngModel)]="email"
					name="email"
					placeholder="E-mail"
					email
				>
			</div>

			<!-- <div>
				<input class="uk-input"
					type="text"
					[(ngModel)]="address"
					name="address"
					placeholder="Улица, дом, квартира *"
					required
				>
			</div>

			<div>
				<input class="uk-input"
					type="text"
					[(ngModel)]="region"
					name="region"
					placeholder="Регион *"
					required
				>
			</div>

			<div>
				<input class="uk-input"
					type="text"
					[(ngModel)]="post_index"
					name="index"
					placeholder="Индекс *"
					pattern="^[0-9]{6}$"
					required
				>
			</div> -->
		</div>

		<div class="uk-child-width-1-2 uk-child-width-1-3@m uk-child-width-1-4@l uk-grid" uk-grid>
			<div>
				<input class="uk-input"
					type="text"
					[(ngModel)]="city"
					name="city"
					placeholder="Город"
				>
			</div>
		</div>
	</div>

	<!-- <h2 class="Heading Heading--marginLeft uk-margin-xlarge-top">Способ оплаты</h2>
	<div class="ContainerSmall">
		<div class="uk-child-width-1-2@m" uk-grid>
			<div *ngFor="let paySystem of paySystems" class="uk-flex uk-flex-middle">
				<label class="OrderPropItem RadioBtn uk-position-relative uk-flex-inline uk-flex-middle"
					[ngClass]="paySystem.CODE ? 'RadioBtn--' + paySystem.CODE : ''"
				>
					<input type="radio" name="paySystem" [value]="paySystem.ID" [(ngModel)]="paySystemId" required>
					<span class="RadioFlag"></span>
					<span>{{paySystem.NAME}}</span>
					<span *ngIf="paySystem.LOGOTIP" class="OrderPropItem_Logo uk-background-contain uk-position-center-right"
						[style.background-image]="'url('+paySystem.LOGOTIP.SRC+')'"
					></span>
				</label>
			</div>
		</div>
	</div>

	<h2 class="Heading Heading--marginLeft uk-margin-xlarge-top">Доставка</h2>
	<div class="ContainerSmall">
		<div class="uk-child-width-1-2@m" uk-grid>
			<div *ngFor="let delivery of deliveries" class="uk-flex uk-flex-middle">
				<label class="OrderPropItem RadioBtn uk-position-relative uk-flex-inline uk-flex-middle"
					[ngClass]="delivery.CODE ? 'RadioBtn--' + delivery.CODE : ''"
				>
					<input type="radio" name="delivery" [value]="delivery.ID" [(ngModel)]="deliveryId" required>
					<span class="RadioFlag"></span>
					<span>{{delivery.NAME}}</span>
					<span *ngIf="delivery.LOGOTIP" class="OrderPropItem_Logo uk-background-contain uk-position-center-right"
						[style.background-image]="'url('+delivery.LOGOTIP.SRC+')'"
					></span>
				</label>
			</div>
		</div>
	</div> -->

	<div class="ContainerSmall uk-margin-xlarge-top">
		<div class="uk-text-right">
			<button class="uk-button uk-button-primary"
				type="submit"
				[disabled]="loadingState || !orderForm.form.valid"
				[ngClass]="loadingState ? 'uk-button-loading' : ''"
			>Оформить заказ</button>
		</div>
	</div>
</form>
